<template>
    <div class="inspect-store-module">
        <!-- 顶部店铺信息 -->
        <div class="store-header">
            <div class="store-header-top">
                <div class="store-title">{{ storeInfo.storeName }}</div>
            </div>
            <div class="store-addr">
                <img class="icon" src="https://mlty-wecom-beauty.oss-cn-shanghai.aliyuncs.com/20251201/address.png" alt="">
                <div class="addr-text">
                    {{ storeInfo.address }}
                </div>
            </div>
        </div>

        <!-- Tab 导航 -->
        <div class="tab-box">
            <van-tabs animated v-model="activeName" @change="clickTab">
                <van-tab title="店铺成员" name="members" v-if="checkPermission('work:quality:members')"> </van-tab>
                <van-tab title="巡店报告" name="reports" v-if="checkPermission('work:quality:reports')"> </van-tab>
                <van-tab title="报备事项" name="records" v-if="checkPermission('work:quality:records')"> </van-tab>
            </van-tabs>
        </div>

        <!-- 成员列表 -->
        <div class="list-box" v-if="activeName === 'members'">
            <van-pull-refresh v-model="membersRefreshing" @refresh="onMembersRefresh" success-text="刷新成功">
                <van-list v-model="membersLoading" :finished="membersFinished" finished-text="没有更多了" @load="onMembersLoad" :offset="20" :immediate-check="false">
                    <store-member-item v-for="item in employeeList" :key="item.id" :item="item" />
                </van-list>
            </van-pull-refresh>
        </div>

        <!-- 巡店报告列表 -->
        <div class="reports-box" v-else-if="activeName === 'reports'" :style="{ height: postType == 1 ? 'calc(100vh - 120px)' : 'calc(100vh - 180px)' }">
            <van-pull-refresh v-model="reportRefreshing" @refresh="onReportsRefresh" success-text="刷新成功">
                <van-list v-model="reportLoading" :finished="reportFinished" finished-text="没有更多了" @load="onReportsLoad" :offset="20" :immediate-check="false">
                    <inspect-report-item v-for="item in reportList" :key="item.id" :item="item" :postType="postType" @track="onTrackIssue" @view="onViewReport" />
                </van-list>
            </van-pull-refresh>
        </div>

        <!-- 报备事项列表 -->
        <div class="records-box" v-else-if="activeName === 'records'">
            <reportList ref="reportRef" :storeNo="storeInfo.storeNo" :storeName="storeInfo.storeName" :hideSearch="postType == 10" />
        </div>
    </div>
</template>

<script>
    import { Toast } from "vant";
    import StoreMemberItem from './components/StoreMemberItem.vue'
    import InspectReportItem from './components/InspectReportItem.vue'
    import reportList from '@/views/CRM/report/list.vue'
    import request from '@/utils/request';
    import { getUserLogin } from '@/api/home';
    export default {
        name: 'inspectStore',
        components: { StoreMemberItem, InspectReportItem, reportList },
        data() {
            return {
                storeInfo: {
                    storeNo: '',
                    storeName: '',
                    address: '',
                },
                activeName: '',
                // 成员列表状态
                membersRefreshing: false,
                membersLoading: false,
                membersFinished: false,
                membersTotal: 0,
                membersPage: 1,
                employeeList: [],
                // 巡店报告状态
                reportRefreshing: false,
                reportLoading: false,
                reportFinished: false,
                reportTotal: 0,
                reportPage: 1,
                reportList: [],
                postType: 1,
                functionPermissionList: [],
            };
        },
        created() {
            getUserLogin().then(res => {
                this.storeInfo.storeNo = this.$route.query.storeId || '';
                this.functionPermissionList = res.data.functionPermissionList;
                this.$store.commit('user/SET_POST_TYPE', res.data.postClassifyCode)
                this.postType = Number(res.data.postClassifyCode);
                this.getStoreInfo();
                this.activeName = this.$route.query.activeName || 'members';
            })
        },
        watch: {
            activeName(newVal, oldVal) {
                if (newVal === 'members') {
                    this.onMembersRefresh();
                } else if (newVal === 'reports') {
                    this.onReportsRefresh();
                }
            }
        },
        methods: {
            clickTab(name) {
                this.activeName = name;
                this.$router.replace({ query: { ...this.$route.query, activeName: name } });
            },
            getStoreInfo() {
                request.get(`/visit-app/qry-store-address?storeNo=${this.storeInfo.storeNo}`).then(res => {
                    this.storeInfo = { ...res.data, storeNo: res.data.storeId }
                }).catch(error => {
                    Toast({ position: 'top', message: error ?? '' })
                })
            },
            // 成员列表：刷新
            onMembersRefresh() {
                this.membersPage = 1
                this.membersFinished = false
                this.membersLoading = false
                this.employeeList = [];
                this.membersRefreshing = false;
                this.onMembersLoad();
            },
            // 成员列表：加载更多
            onMembersLoad() {
                this.membersLoading = true
                request({
                    url: `/rectify-audit/queryStoreEmpInfoList?storeNo=${this.storeInfo.storeNo}`,
                    method: "get",
                })
                    .then((res) => {
                        this.employeeList = this.membersPage == 1 ? res.data : this.employeeList.concat(res.data);
                        this.membersPage += 1;
                        this.membersTotal = this.employeeList.length;
                    }).catch((error) => {
                        this.membersFinished = true
                        Toast({ position: 'top', message: error ?? '' })
                    }).finally(() => {
                        this.membersLoading = false;
                        if (this.employeeList.length >= this.membersTotal) {
                            this.membersFinished = true;
                        }
                    });
            },
            // 报告列表：刷新
            onReportsRefresh() {
                this.reportPage = 1
                this.reportFinished = false
                this.reportLoading = false
                this.reportList = [];
                this.reportRefreshing = false;
                this.onReportsLoad();
            },
            // 报告列表：加载更多
            onReportsLoad() {
                this.reportLoading = true
                request({
                    url: `/visit-app/qry-store-reports?storeNo=${this.storeInfo.storeNo}&limit=10&page=${this.reportPage}`,
                    method: "get",
                })
                    .then((res) => {
                        this.reportList = this.reportPage == 1 ? res.data.list : this.reportList.concat(res.data.list);
                        this.reportPage = Number(res.data.pageNum) + 1;
                        this.reportTotal = res.data.total;
                    }).catch((error) => {
                        this.reportFinished = true
                        Toast({ position: 'top', message: error ?? '' })
                    }).finally(() => {
                        this.reportLoading = false;
                        if (this.reportList.length >= this.reportTotal) {
                            this.reportFinished = true;
                        }
                    });
            },
            onTrackIssue(item) {
                this.$router.push({ name: 'issueTrack', query: { questionnaireId: item.questionnaireId, assessmentId: item.assessmentId } })
            },
            onViewReport(item) {
                this.$router.push({ name: 'storeReport', query: { assessmentId: item.assessmentId } })
            },
            checkPermission(code) {
                return this.functionPermissionList.some(item => item === code)
            }
        }
    };
</script>
<style scoped lang="less">
    .inspect-store-module {
        background: #fff;
        min-height: 100vh;
        font-family: PingFangSC, PingFang SC;
    }

    .store-header {
        padding: 24px 30px 12px 30px;
        border-bottom: 20px solid #F9FAFC;
    }

    .store-header-top {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .store-title {
        font-size: 38px;
        font-weight: 500;
        color: #35434c;
    }

    .actions {
        display: flex;
    }



    .store-addr {
        margin-top: 20px;
        display: flex;
        align-items: center;
        color: #a0acb5;
    }

    .store-addr .icon {
        width: 22px;
        height: 25px;
        margin-right: 20px;
    }

    .addr-text {
        flex: 1;
        font-size: 26px;
    }

    .tab-box {
        margin-top: 18px;
    }

    :deep(.van-tabs__line) {
        display: none;
    }

    :deep(.van-tabs__wrap) {
        display: flex;
        justify-content: center;
    }

    :deep(.van-tab) {
        flex: none !important;
        width: 190px !important;
        padding: 0 !important;
        height: 64px !important;
        line-height: 64px !important;
        color: #a0acb5;
        font-size: 30px;
        margin: 0 18px;
    }

    :deep(.van-tab.van-tab--active) {
        background: #2fd0d5 !important;
        border-radius: 30px !important;
        color: #fff !important;
    }

    :deep(.van-tab.van-tab--active .van-tab__text) {
        font-weight: 700;
    }

    .van-pull-refresh {
        min-height: 100%;
    }

    :deep(.van-list) {
        min-height: 100%;
    }

    .list-box {
        margin-top: 8px;
        min-height: 100vh;
        height: calc(100vh - 310px);
        overflow: auto;
    }

    .reports-box {
        margin-top: 12px;
        // padding-bottom: 40px;
        overflow: auto;
    }

    .records-box {
        margin-top: 12px;
        // padding-bottom: 40px;
        overflow: auto;
        height: calc(100vh - 310px);
    }

    :deep(.van-pull-refresh) {
        min-height: 100%;
    }

    :deep(.van-tabs--line .van-tabs__wrap) {
        height: auto !important;
    }

    :deep(.van-tabs__nav--line) {
        padding-bottom: 0 !important;
    }
</style>